import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { IconClose } from 'svgIcons/MotionPortalIcons';
import { getNotificationIcon } from 'helpers/notificationIconHelper';
import colors from 'theme/_colors.scss';
import { translate } from 'helpers/translateHelper';
import { NOTIFICATION_BAR } from 'helpers/constants';

const NotificationStatusBarContent = ({ notification, onClose, isHide, value, contractInfo, showClose, coloredIcon }) => {
    return <Row className={isHide || value ? 'notification-row' : 'notification-row d-none'}>
        <Col>
            <div className={value ? `notification-status-bar ${contractInfo?.type}-status-bar` : `notification-status-bar ${notification}-status-bar`} >
                <div>
                    <div className='notification-icon-container'>
                        {value ? getNotificationIcon(contractInfo?.type, coloredIcon) : getNotificationIcon(notification, coloredIcon)}
                    </div>
                    {!value ? <span className='notification-status-bar-text'>{translate('ABB.Powertrain.Frontend.FreeForRenewalNTFMsg')}
                        <a className='link' href={NOTIFICATION_BAR.CONVERTURL} rel='noreferrer' target='_blank'>{translate('ABB.Powertrain.Frontend.ContactDriveSupport')}</a>
                    </span> : <span className={'notification-status-bar-text'}>{translate(contractInfo?.message, { endDate: contractInfo?.messageParams?.endDate })}
                        {contractInfo?.link ? <a className='link' href={contractInfo?.link?.url} rel='noreferrer' target='_blank'>{translate('ABB.Powertrain.Frontend.ContactABBDriveSupport')}</a> : ''}</span>}
                </div>
                {showClose ?
                    <div
                        id='closeNotifyButton'
                        role='presentation'
                        onClick={onClose}
                    >
                        <IconClose
                            color={coloredIcon ? colors.mineShaft : colors.white}
                            strokeWidth='6' />
                    </div> : null}
            </div></Col>
    </Row>;
};

NotificationStatusBarContent.propTypes = {
    // REVERT TO THIS while adding the blue and yellow banner
    // notification: PropTypes.shape({
    //     link: PropTypes.shape({
    //         description: PropTypes.string,
    //         url: PropTypes.string,
    //     }),
    //     message: PropTypes.string,
    //     type: PropTypes.string,
    // }),
    notification: PropTypes.oneOfType([PropTypes.oneOf(Object.values(NOTIFICATION_BAR)), PropTypes.string]), // Notification type (e.g., FREE, FREE_FOR_RENEWAL)
    onClose: PropTypes.func, // Function to handle the close action
    isHide: PropTypes.bool, // Whether the notification bar is hidden
    value: PropTypes.bool, // Whether the notification bar is active
    contractInfo: PropTypes.shape({
        message: PropTypes.string, // Notification message
        type: PropTypes.string, // Notification type
        messageParams: PropTypes.shape({
            endDate: PropTypes.string, // End date parameter for the message
        }), // Parameters for the notification message
        link: PropTypes.shape({
            description: PropTypes.string, // Link description
            url: PropTypes.string, // Link URL
        }), // Link details
    }), // Contract information for the notification
};

export default NotificationStatusBarContent;
